module.exports = __webpack_public_path__ + "img/residence-permit-do.9b8152ca.png";